export const getUrlResizeImage = (url, size) => {
  if (size === '600_800') return url + '&resize=600_800';
  if (size === '300_400') return url + '&resize=300_400';
  if (size === '150_200') return url + '&resize=150_200';
  if (size === '75_100') return url + '&resize=75_100';

  return url;
};
